<template>
<div class="main">
    <div class="search-imp">
        <el-form :inline="true" :model="query" class="demo-form-inline">
            <el-form-item>
                <el-button-group>
                    <el-button type="primary" @click="$refs.editForm.showDrawer('')">添加</el-button>
                </el-button-group>
            </el-form-item>
            <el-form-item label="平台编号">
                <el-input v-model="query.id" placeholder="平台编号" clearable></el-input>
            </el-form-item>
            <el-form-item label="平台名称">
                <el-input v-model="query.title" placeholder="平台名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="doSearch">查询</el-button>
            </el-form-item>
        </el-form>
    </div>
    <el-table :data="tableData" style="width: 100%" v-loading="loading">
        <el-table-column prop="id" label="编号" width="100">
        </el-table-column>
        <el-table-column prop="title" label="平台名称">
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="160" align="center">
        </el-table-column>
        <el-table-column prop="is_valid" label="上/下线" width="160" align="center">
        </el-table-column>
        <el-table-column label="操作" width="200">
            <template slot-scope="scope">
                <el-button-group>
                    <el-button @click="$refs.store.showStoreList(scope.row)" type="primary" size="mini">门店</el-button>
                    <el-button @click="$refs.editForm.showDrawer(scope.row)" type="success" size="mini">编辑</el-button>
                    <el-button @click="deleteFn(scope.$index,scope.row)" type="warning" size="mini">删除</el-button>
                </el-button-group>
            </template>
        </el-table-column>
    </el-table>

    <store ref="store"></store>
    <editForm ref="editForm" v-on:getTableData="getTableData"></editForm>
    <div class="fixed-bottom">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[15, 20, 30, 50]" :page-size="pagination.limit" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
        </el-pagination>
    </div>
</div>
</template>

<script>
import store from './store';
import editForm from './edit';

export default {
    components: {
        store,
        editForm
    },
    data() {
        return {
            loading: false,

            name: 'Parent',
            query: {
                id: '',
                title: ''
            },
            tableData: [],
            pagination: {
                page: 1,
                limit: 30,
                total: 0
            }
        };
    },
    created() {
        this.getTableData();
    },
    methods: {
        getTableData() { //获取表格列表
            let that = this;
            let url = '/api/promoter.platform/index';
            let query = this.query;
            query.pagination = this.pagination;
            that.loading = true;
            this.$post(url, query).then(function (response) {
                let result = response.data;
                that.tableData = result.list;
                that.pagination = result.pagination;
                that.loading = false;
            });
        },
        doSearch() { // 搜索
            this.getTableData();
        },
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },
         deleteFn(index,e){
            let _this=this                       
            this.$confirm('此操作将, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                    let url = '/api/promoter.platform/delete';
                    let query = {id:e.id};                    
                    _this.loading = true;
                    this.$post(url, query).then(function (response) {
                        
                        if(response.code==200){
                            _this.tableData.splice(index,1)
                        }
                        _this.loading = false
                        _this.$message({
                            type: 'success',
                            message: response.msg
                        });
                        
                    });
               
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        }
    }
}
</script>

<style>
.main{
    padding: 12px;
}

.search-imp{
    margin: 0;
}
.fixed-bottom{
    padding: 12px 0;
    text-align: end;
}
</style>
